import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Store from './services/store/Store';
import Server from './services/server/Server';
import Popup from './components/Popup/Popup';
import AchievementNotification from './components/AchievementNotification/AchievementNotification';
import AppInitializer from './components/AppInitializer/AppInitializer';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import AppRoutes from './routes/routes';
import { ThemeProvider } from './context/ThemeContext';

export const StoreContext = React.createContext<Store>(null!);
export const ServerContext = React.createContext<Server>(null!);

const App: React.FC = () => {
    const store = new Store();
    const server = new Server(store);

    return (
        <ErrorBoundary>
            <HelmetProvider>
                <ThemeProvider>
                    <StoreContext.Provider value={store}>
                        <ServerContext.Provider value={server}>
                            <BrowserRouter>
                                <AppInitializer>
                                    <div className='app'>
                                        <Popup />
                                        <AchievementNotification />
                                        <AppRoutes />
                                    </div>
                                </AppInitializer>
                            </BrowserRouter>
                        </ServerContext.Provider>
                    </StoreContext.Provider>
                </ThemeProvider>
            </HelmetProvider>
        </ErrorBoundary>
    );
}

export default App;